// extracted by mini-css-extract-plugin
export default {"helpContent":"HelpTab_helpContent__daZgd","openButton":"HelpTab_openButton__+O2rR","icon":"HelpTab_icon__A8qBC"};